module.exports = {"350821100":"汀州镇","350821101":"大同镇","350821102":"古城镇","350821103":"新桥镇","350821104":"馆前镇","350821105":"童坊镇","350821106":"河田镇","350821107":"南山镇","350821108":"濯田镇","350821109":"四都镇","350821110":"涂坊镇","350821111":"策武镇","350821112":"三洲镇","350821201":"铁长乡","350821202":"庵杰乡","350821204":"宣成乡","350821205":"红山乡","350821206":"羊牯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350821.json
// module id = 1135
// module chunks = 0